import { render, staticRenderFns } from "./AssignToModeratorListener.vue?vue&type=template&id=22327b77"
import script from "./AssignToModeratorListener.vue?vue&type=script&lang=js"
export * from "./AssignToModeratorListener.vue?vue&type=script&lang=js"
import style0 from "./AssignToModeratorListener.vue?vue&type=style&index=0&id=22327b77&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports